var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "152px",
    height: "152px",
    viewBox: "0 0 152 152",
    enableBackground: "new 0 0 152 152",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M19.486,80.302c0.031,31.031,25.26,56.261,56.26,56.261c31.031,0,56.26-25.229,56.26-56.261 c0-31.032-25.229-56.26-56.26-56.26C44.716,24.042,19.486,49.27,19.486,80.302z M75.747,28.574 c28.523,0,51.729,23.205,51.729,51.728c0,28.522-23.206,51.729-51.729,51.729c-28.523,0-51.728-23.207-51.728-51.729 C24.019,51.779,47.224,28.574,75.747,28.574z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M120.795,24.521c-6.857-5.558-14.807-9.874-23.537-12.628c0.156-0.479,0.216-0.967,0.216-1.475 c0,0,0,0,0-0.029c0.429-1.689,4.663-9.071,3.071-9.071l-3.624,0.02c-0.021,1.244-3.518,8.78-4.125,9.65 c-0.642,0.918-1.48,1.424-1.211,2.721c0.175,0.85,0.81,1.514,1.63,1.719c29.308,7.892,49.729,34.573,49.7,64.848 c0,37.044-30.089,67.133-67.133,67.163c-37.053-0.03-67.143-30.128-67.143-67.173C8.61,50.001,29.031,23.32,58.349,15.428 c0.811-0.214,1.445-0.878,1.63-1.719c0.441-1.999-1.481-3.26-2.281-4.845c-0.347-0.687-3.779-7.526-3.779-7.526 c-0.908,0-1.475-0.01-1.601-0.02h-2.315c-0.85,1.026,3.462,7.284,4.078,9.062c0,0,0,0,0,0.029c0,0.517,0.059,1.006,0.215,1.484 c-8.731,2.754-16.681,7.07-23.537,12.628C14.294,37.822,4.078,58.156,4.078,80.306c0,19.767,8.038,37.698,21.017,50.679 C38.084,143.961,56.005,152,75.782,152c39.544,0,71.694-32.149,71.694-71.694C147.476,58.156,137.261,37.852,120.795,24.521z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRing);
export default __webpack_public_path__ + "static/media/empty-ring.5acd62d006680237522fb2ac088697d7.svg";
export { ForwardRef as ReactComponent };